// @dynamic-i18n-keys
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import {
  formatDate,
  DATE_FORMATS,
  dateToRelativeTrans,
  parseIsoDateOrTimestamp,
} from '@wix/da-i18next/pkg/time/functions';

import s from './Timestamp.scss';

export interface Props {
  /**
    timestamp should be API format
  */
  timestamp?: string;
  showTooltip?: boolean;
  className?: string;
  isShort?: boolean;
  isCapitalized?: boolean;
  showFullLengthOnMobile?: boolean;
}

const Timestamp: React.FC<Props> = ({
  className,
  timestamp,
  showTooltip,
  isShort,
  isCapitalized,
  showFullLengthOnMobile,
}) => {
  const { t, i18n } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isMounted = useIsMounted();

  if (!timestamp) {
    return null;
  }

  const relativeTrans = dateToRelativeTrans(
    timestamp,
    (isMobile && !showFullLengthOnMobile) || isShort,
    false,
    i18n.language
  );
  const formattedDate = formatDate(
    timestamp,
    DATE_FORMATS.DateTime.FullTimeZone,
    i18n.language
  );

  return (
    <time
      aria-label={formattedDate}
      dateTime={parseIsoDateOrTimestamp(timestamp).toISOString()}
      className={classnames(isCapitalized && s['capitalize'], className)}
      title={showTooltip && isMounted ? formattedDate : undefined}
      suppressHydrationWarning
    >
      {t(relativeTrans.key, { count: relativeTrans.value })}
    </time>
  );
};
Timestamp.displayName = 'Timestamp';

export default React.memo(Timestamp);
